import appVideo from './index.vue'

const components={
  install(Vue){
    Vue.component('view-video', appVideo)
  }
}

if(typeof window !=='undefined' && window.Vue){
  install(window.Vue);
}
 
export default components;
